<template>
  <auth-card title="Connexion" subtitle="Accédez à vos sections favorites et à votre espace membre.">
    <v-alert
      class="mb-4"
      color="primary"
      icon="mdi-account-alert-outline"
      variant="tonal"
      density="compact"
    >
      Vous aviez un compte sur l'ancienne plateforme? Créez un nouveau compte sur celle-ci.
    </v-alert>
    <v-alert v-if="errorMessage" class="mb-4" type="error" variant="tonal" density="compact">
      {{ errorMessage }}
    </v-alert>
    <v-form ref="form" v-model="valid" @submit="submitAction" :disabled="isLoading">
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="Courriel"
        type="email"
        autocomplete="email"
        prepend-inner-icon="mdi-email-outline"
        class="mb-2"
        :disabled="isLoading"
        required
        @focus="clearErrorsOnFocus"
      ></v-text-field>
      <v-text-field
        v-model="password"
        :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :rules="passwordRules"
        label="Mot de passe"
        :type="showPassword ? 'text' : 'password'"
        name="password"
        autocomplete="current-password"
        prepend-inner-icon="mdi-lock-outline"
        :disabled="isLoading"
        @click:append-inner="showPassword = !showPassword"
        @focus="clearErrorsOnFocus"
      ></v-text-field>
      <div class="d-flex justify-end mb-4">
        <router-link :to="{ name: 'reinitialiser-mot-de-passe' }" class="auth-link text-section-name text-body-small">
          Mot de passe oublié?
        </router-link>
      </div>
      <v-btn
        :disabled="!valid || isLoading"
        :loading="isLoading"
        color="primary"
        size="large"
        block
        type="submit"
      >
        Connexion
      </v-btn>
    </v-form>
    <template #footer>
      Pas encore de compte?
      <router-link :to="{ name: 'nouvel-utilisateur' }" class="auth-link text-section-name font-weight-bold">Créer un compte</router-link>
    </template>
  </auth-card>
</template>

<script>
  import { auth } from "@/firebase";
  import AuthCard from "@/components/AuthCard.vue";

  export default {
    components: { AuthCard },
    data() {
      return {
        valid: true,
        email: "",
        emailRules: [
          (v) => !!v || "Un courriel est requis",
          (v) => /.+@.+\..+/.test(v) || "Le courriel doit être valide",
        ],
        password: "",
        passwordRules: [(value) => !!value || "Un mot de passe est requis"],
        showPassword: false,
        isLoading: false,
        errorMessage: false,
      };
    },
    methods: {
      async submitAction(evt) {
        evt.preventDefault();
        if (this.isLoading) return;
        this.isLoading = true;

        try {
          await auth.signInWithEmailAndPassword(this.email, this.password);
          await this.$router.push({ name: "accueil" });
        } catch (error) {
          if (error && error.code === "auth/too-many-requests") {
            this.errorMessage =
              "Trop de tentatives de connexion. Veuillez patienter quelques minutes avant de réessayer.";
          } else {
            this.errorMessage = "Email ou mot de passe erroné";
          }
          console.log("error", error);
        } finally {
          this.isLoading = false;
        }
      },
      initErrorMessage() {
        this.errorMessage = false;
      },
      clearErrorsOnFocus() {
        this.initErrorMessage();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .auth-link {
    text-decoration: none;
  }

  .auth-link:hover {
    text-decoration: underline;
  }
</style>
